import { Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '~/app/components/common/Button';

export interface PlanWizardFooterProps {
  current: number;
  stepCount: number;
  canProceed: boolean;
  isAdvancingAssets: boolean;
  isCreatingWizard: boolean;
  isPreviewingWizard: boolean;
  onCancel: () => void;
  onBack: () => void;
  onNext: () => void;
  onSave: () => void;
}

export function PlanWizardFooter({
  current,
  stepCount,
  canProceed,
  isAdvancingAssets,
  isCreatingWizard,
  isPreviewingWizard,
  onCancel,
  onBack,
  onNext,
  onSave,
}: PlanWizardFooterProps) {
  const { t } = useTranslation('maintenance');

  return (
    <Row justify="space-between">
      <Button onClick={onCancel}>{t('wizard.cancel')}</Button>
      <Space>
        {current > 0 && <Button onClick={onBack}>{t('wizard.back')}</Button>}
        {current < stepCount - 1 ? (
          <Button
            type="primary"
            disabled={!canProceed || isAdvancingAssets}
            loading={isAdvancingAssets}
            onClick={onNext}
          >
            {current === 2
              ? t('wizard.assets.continueToReview')
              : t('wizard.next')}
          </Button>
        ) : (
          <Button
            type="primary"
            loading={isCreatingWizard}
            disabled={!canProceed || isPreviewingWizard}
            onClick={onSave}
          >
            {isCreatingWizard
              ? t('wizard.review.saving')
              : t('wizard.review.confirm')}
          </Button>
        )}
      </Space>
    </Row>
  );
}
